(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coin-guide-feedback-patch"] && !Shopify.designMode) return;
  try {
    
(function() {
  var ROOSEVELT_DIME_IMAGE = 'https://cdn.shopify.com/s/files/1/0661/4856/5211/files/coin-guide-roosevelt-dime-1989-neutral.jpg?v=1787638480';

  function stabilizeRooseveltDimeImages(root) {
    var cards = root.querySelectorAll('.cg-realcoin');

    for (var i = 0; i < cards.length; i += 1) {
      if (cards[i].textContent.indexOf('Roosevelt Dime') === -1) continue;

      var images = cards[i].querySelectorAll('img');
      for (var j = 0; j < images.length; j += 1) {
        images[j].loading = 'eager';
        images[j].decoding = 'async';
        images[j].removeAttribute('srcset');
        images[j].src = ROOSEVELT_DIME_IMAGE;
      }

      break;
    }
  }

  function initCoinGuideFeedbackPatch() {
    var root = document.querySelector('.cg');
    if (!root || root.dataset.feedbackPatchV1 === 'true') return;
    root.dataset.feedbackPatchV1 = 'true';

    stabilizeRooseveltDimeImages(root);

    var specs = root.querySelector('#what');
    if (specs) {
      var rows = specs.querySelectorAll('.cg-table tbody tr');
      for (var i = 0; i < rows.length; i += 1) {
        var label = rows[i].querySelector('td:first-child');
        if (label && label.textContent.indexOf('Lincoln Cent') !== -1) {
          var cells = rows[i].querySelectorAll('td');
          if (cells.length > 1) {
            cells[1].textContent = '1909–2026 family; 1982 transition; circulating production ended in 2025; 2026 collectible annual-set issue';
          }
          break;
        }
      }

      var note = specs.querySelector('.cg-note');
      if (note) {
        note.innerHTML = '<strong>Weight note:</strong> Listed weights are nominal Mint specifications for newly struck coins. Manufacturing tolerances apply, and circulated coins may weigh less because of wear. For Lincoln cents, historical tolerances are about ±0.13 g (1909–1971), ±0.12 g (1972–1982) and ±0.10 g for copper-plated zinc cents. Compare 1943 steel cents and 1982 transition pieces with the correct type. Weight alone does not confirm an error or authenticity.';
      }

      var seriesItems = specs.querySelectorAll('.cg-seriesitem');
      for (var j = 0; j < seriesItems.length; j += 1) {
        var title = seriesItems[j].querySelector('b');
        if (title && title.textContent.trim() === '$1 Dollar') {
          var description = seriesItems[j].querySelector('span');
          if (description) {
            description.textContent = 'Large dollars: Morgan, Peace and Eisenhower (1971–1978). Small dollars: Susan B. Anthony (1979–1981, 1999), Sacagawea / Native American (2000–present), Presidential (2007–2016; 2020), American Innovation (2018–present) and the one-year 2026 Semiquincentennial $1 issue.';
          }

          var collector = document.createElement('div');
          collector.className = 'cg-seriesitem cg-seriesitem--collector';
          collector.innerHTML = '<b>Collector bullion • $1</b><span>American Silver Eagle (1986–present): 40.60 mm • 31.103 g (1 troy oz.) • .999 silver. Bullion coins generally have no mint mark; collector versions carry mint marks that vary by year and issue.</span>';
          seriesItems[j].insertAdjacentElement('afterend', collector);
          break;
        }
      }
    }

    var transitions = root.querySelector('#transitions');
    if (transitions) {
      var transitionCards = transitions.querySelectorAll('.cg-transition');
      for (var k = 0; k < transitionCards.length; k += 1) {
        var marker = transitionCards[k].querySelector('strong');
        if (marker && marker.textContent.indexOf('2026') !== -1) {
          var copy = transitionCards[k].querySelector('p');
          if (copy) {
            copy.textContent = 'A collectible 1776–2026 Lincoln cent appears in 2026 U.S. Mint annual sets after circulating cent production ended in 2025. The dime uses Emerging Liberty, the half dollar uses Enduring Liberty, quarters use five anniversary designs, and the Jefferson nickel carries a 1776–2026 dual date. Do not compare these issues with a normal 2025 layout.';
          }
          break;
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCoinGuideFeedbackPatch);
  } else {
    initCoinGuideFeedbackPatch();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coin-guide-quality-patch"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCoinGuideQualityPatch() {
    var root = document.querySelector('.cg');
    if (!root || root.dataset.qualityPatchV1 === 'true') return;
    root.dataset.qualityPatchV1 = 'true';

    var DIME_BOTH = 'https://cdn.shopify.com/s/files/1/0661/4856/5211/files/coin-guide-roosevelt-dime-1989-neutral.jpg?v=1787638480';
    var MORGAN_BOTH = 'https://cdn.shopify.com/s/files/1/0661/4856/5211/files/coin-guide-morgan-dollar-1921-hires.jpg?v=1787638491';

    function findCard(name) {
      var cards = root.querySelectorAll('.cg-realcoin');
      for (var i = 0; i < cards.length; i += 1) {
        var heading = cards[i].querySelector('.cg-coininfo h3');
        if (heading && heading.textContent.trim() === name) return cards[i];
      }
      return null;
    }

    function faces(card) {
      return card ? card.querySelectorAll('.cg-face img') : [];
    }

    function zooms(card) {
      return card ? card.querySelectorAll('.cg-zoom-window img') : [];
    }

    function setSource(img, url, alt) {
      if (!img) return;
      img.removeAttribute('srcset');
      if (alt) img.alt = alt;
      if (img.src === url) return;
      img.src = url;
    }

    function paintCrop(img, crop) {
      if (!img || !crop) return;
      var box = img.closest('.cg-face, .cg-zoom-window');
      if (!box) return;
      img.dataset.cgCrop = [crop.x, crop.y, crop.w, crop.h].join(',');
      box.classList.add('cg-crop-active');
      box.style.setProperty('--cg-crop-img-w', (10000 / crop.w) + '%');
      box.style.setProperty('--cg-crop-img-h', (10000 / crop.h) + '%');
      box.style.setProperty('--cg-crop-img-left', (-100 * crop.x / crop.w) + '%');
      box.style.setProperty('--cg-crop-img-top', (-100 * crop.y / crop.h) + '%');
    }

    function cropAroundFocus(img, focusX, focusY, zoomFactor) {
      var nw = img.naturalWidth;
      var nh = img.naturalHeight;
      if (!nw || !nh) return null;
      var cropW = nw / zoomFactor;
      var cropH = cropW / (4 / 3);
      if (cropH > nh) {
        cropH = nh / zoomFactor;
        cropW = cropH * (4 / 3);
      }
      var cx = nw * focusX / 100;
      var cy = nh * focusY / 100;
      var x = Math.min(Math.max(cx - cropW / 2, 0), nw - cropW);
      var y = Math.min(Math.max(cy - cropH / 2, 0), nh - cropH);
      return { x: x / nw * 100, y: y / nh * 100, w: cropW / nw * 100, h: cropH / nh * 100 };
    }

    function squareSideCrop(img, side) {
      var nw = img.naturalWidth;
      var nh = img.naturalHeight;
      if (!nw || !nh) return null;
      var sideW = nw / 2;
      var square = Math.min(sideW, nh);
      var xPx = side === 'right' ? nw - sideW + (sideW - square) / 2 : (sideW - square) / 2;
      var yPx = (nh - square) / 2;
      return { x: xPx / nw * 100, y: yPx / nh * 100, w: square / nw * 100, h: square / nh * 100 };
    }

    function cropWithinSide(img, side, focusX, focusY, zoomFactor) {
      var nw = img.naturalWidth;
      var nh = img.naturalHeight;
      if (!nw || !nh) return null;
      var sideW = nw / 2;
      var regionSize = Math.min(sideW, nh);
      var regionX = side === 'right' ? nw - sideW + (sideW - regionSize) / 2 : (sideW - regionSize) / 2;
      var regionY = (nh - regionSize) / 2;
      var cropW = regionSize / zoomFactor;
      var cropH = cropW / (4 / 3);
      var cx = regionX + regionSize * focusX / 100;
      var cy = regionY + regionSize * focusY / 100;
      var x = Math.min(Math.max(cx - cropW / 2, regionX), regionX + regionSize - cropW);
      var y = Math.min(Math.max(cy - cropH / 2, regionY), regionY + regionSize - cropH);
      return { x: x / nw * 100, y: y / nh * 100, w: cropW / nw * 100, h: cropH / nh * 100 };
    }

    function afterLoad(img, callback) {
      if (!img) return;
      if (img.complete && img.naturalWidth) {
        callback();
      } else {
        img.addEventListener('load', callback, { once: true });
      }
    }

    function fixLincoln() {
      var card = findCard('Lincoln Cent');
      var z = zooms(card);
      if (z.length < 2) return;
      afterLoad(z[0], function() { paintCrop(z[0], cropAroundFocus(z[0], 74, 78, 1.65)); });
      afterLoad(z[1], function() { paintCrop(z[1], cropAroundFocus(z[1], 50, 89, 1.65)); });
    }

    function fixJefferson() {
      var card = findCard('Jefferson Nickel');
      var z = zooms(card);
      if (z.length < 2) return;
      afterLoad(z[0], function() { paintCrop(z[0], cropAroundFocus(z[0], 74, 76, 1.55)); });
      afterLoad(z[1], function() { paintCrop(z[1], cropAroundFocus(z[1], 50, 29, 1.50)); });
    }

    function replaceDime() {
      var card = findCard('Roosevelt Dime');
      var f = faces(card);
      var z = zooms(card);
      if (f.length < 2 || z.length < 2) return;
      setSource(f[0], DIME_BOTH, '1989 Roosevelt dime obverse real coin photograph');
      setSource(f[1], DIME_BOTH, '1989 Roosevelt dime reverse real coin photograph');
      setSource(z[0], DIME_BOTH, 'Roosevelt dime date and mint mark magnified');
      setSource(z[1], DIME_BOTH, 'Roosevelt dime torch bands magnified');
      afterLoad(f[0], function() { paintCrop(f[0], squareSideCrop(f[0], 'left')); });
      afterLoad(f[1], function() { paintCrop(f[1], squareSideCrop(f[1], 'right')); });
      afterLoad(z[0], function() { paintCrop(z[0], cropWithinSide(z[0], 'left', 74, 80, 1.95)); });
      afterLoad(z[1], function() { paintCrop(z[1], cropWithinSide(z[1], 'right', 50, 50, 1.90)); });
      var source = card.querySelector('.cg-source');
      if (source) source.href = 'https://commons.wikimedia.org/wiki/File:1_Dime_(United_States).jpg';
    }

    function replaceMorgan() {
      var card = findCard('Morgan Dollar');
      var f = faces(card);
      var z = zooms(card);
      if (f.length < 2 || z.length < 2) return;
      setSource(f[0], MORGAN_BOTH, '1921 Morgan dollar obverse high-resolution real coin photograph');
      setSource(f[1], MORGAN_BOTH, '1921 Morgan dollar reverse high-resolution real coin photograph');
      setSource(z[0], MORGAN_BOTH, 'Morgan dollar date and lower stars magnified');
      setSource(z[1], MORGAN_BOTH, 'Morgan dollar lower reverse magnified');
      afterLoad(f[0], function() { paintCrop(f[0], squareSideCrop(f[0], 'left')); });
      afterLoad(f[1], function() { paintCrop(f[1], squareSideCrop(f[1], 'right')); });
      afterLoad(z[0], function() { paintCrop(z[0], cropWithinSide(z[0], 'left', 50, 83, 2.25)); });
      afterLoad(z[1], function() { paintCrop(z[1], cropWithinSide(z[1], 'right', 50, 78, 2.20)); });
      var source = card.querySelector('.cg-source');
      if (source) source.href = 'https://commons.wikimedia.org/wiki/File:Moneda_de_1_d%C3%B3lar_USA_1921.jpg';
    }

    window.requestAnimationFrame(function() {
      window.requestAnimationFrame(function() {
        fixLincoln();
        fixJefferson();
        replaceDime();
        replaceMorgan();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCoinGuideQualityPatch);
  } else {
    initCoinGuideQualityPatch();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coin-guide-roosevelt-hd"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initRooseveltHdPatch() {
    var root = document.querySelector('.cg');
    if (!root || root.dataset.rooseveltHdV1 === 'true') return;
    root.dataset.rooseveltHdV1 = 'true';

    var DIME_OBVERSE = 'https://www.usmint.gov/content/dam/usmint/coins/circulating-coins/2025-roosevelt-dime-uncirculated-obverse-philadelphia.jpg';
    var DIME_REVERSE = 'https://www.usmint.gov/content/dam/usmint/coins/circulating-coins/2025-roosevelt-dime-uncirculated-reverse.jpg';

    function findCard(name) {
      var cards = root.querySelectorAll('.cg-realcoin');
      for (var i = 0; i < cards.length; i += 1) {
        var heading = cards[i].querySelector('.cg-coininfo h3');
        if (heading && heading.textContent.trim() === name) return cards[i];
      }
      return null;
    }

    function setSource(img, url, alt) {
      if (!img) return;
      img.removeAttribute('srcset');
      img.referrerPolicy = 'no-referrer';
      img.decoding = 'async';
      if (alt) img.alt = alt;
      img.src = url;
    }

    function paintCrop(img, crop) {
      if (!img || !crop) return;
      var box = img.closest('.cg-face, .cg-zoom-window');
      if (!box) return;
      img.dataset.cgCrop = [crop.x, crop.y, crop.w, crop.h].join(',');
      box.classList.add('cg-crop-active');
      box.style.setProperty('--cg-crop-img-w', (10000 / crop.w) + '%');
      box.style.setProperty('--cg-crop-img-h', (10000 / crop.h) + '%');
      box.style.setProperty('--cg-crop-img-left', (-100 * crop.x / crop.w) + '%');
      box.style.setProperty('--cg-crop-img-top', (-100 * crop.y / crop.h) + '%');
    }

    function cropAroundFocus(img, focusX, focusY, zoomFactor) {
      var nw = img.naturalWidth;
      var nh = img.naturalHeight;
      if (!nw || !nh) return null;
      var cropW = nw / zoomFactor;
      var cropH = cropW / (4 / 3);
      if (cropH > nh) {
        cropH = nh / zoomFactor;
        cropW = cropH * (4 / 3);
      }
      var cx = nw * focusX / 100;
      var cy = nh * focusY / 100;
      var x = Math.min(Math.max(cx - cropW / 2, 0), nw - cropW);
      var y = Math.min(Math.max(cy - cropH / 2, 0), nh - cropH);
      return { x: x / nw * 100, y: y / nh * 100, w: cropW / nw * 100, h: cropH / nh * 100 };
    }

    function afterLoad(img, callback) {
      if (!img) return;
      if (img.complete && img.naturalWidth) callback();
      else img.addEventListener('load', callback, { once: true });
    }

    function apply() {
      var card = findCard('Roosevelt Dime');
      if (!card) return;
      var faces = card.querySelectorAll('.cg-face img');
      var zooms = card.querySelectorAll('.cg-zoom-window img');
      if (faces.length < 2 || zooms.length < 2) return;

      setSource(faces[0], DIME_OBVERSE, '2025-P Roosevelt dime uncirculated obverse, United States Mint image');
      setSource(faces[1], DIME_REVERSE, '2025 Roosevelt dime uncirculated reverse, United States Mint image');
      setSource(zooms[0], DIME_OBVERSE, '2025-P Roosevelt dime date and mint mark magnified, United States Mint image');
      setSource(zooms[1], DIME_REVERSE, 'Roosevelt dime torch bands magnified, United States Mint image');

      afterLoad(faces[0], function() { paintCrop(faces[0], { x: 0, y: 0, w: 100, h: 100 }); });
      afterLoad(faces[1], function() { paintCrop(faces[1], { x: 0, y: 0, w: 100, h: 100 }); });
      afterLoad(zooms[0], function() { paintCrop(zooms[0], cropAroundFocus(zooms[0], 73, 78, 1.65)); });
      afterLoad(zooms[1], function() { paintCrop(zooms[1], cropAroundFocus(zooms[1], 50, 51, 1.70)); });

      var source = card.querySelector('.cg-source');
      if (source) {
        source.href = 'https://www.usmint.gov/news/image-library/circulating';
        source.textContent = 'United States Mint image. Source / use policy';
      }
    }

    window.requestAnimationFrame(function() {
      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(apply);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRooseveltHdPatch);
  } else {
    initRooseveltHdPatch();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coin-guide-zoom-layer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCoinGuideLightboxV2() {
      var root = document.querySelector('.cg');
      var lightbox = document.querySelector('[data-cg-lightbox]');
      if (!root || !lightbox || lightbox.dataset.readyV2 === 'true') return;
      lightbox.dataset.readyV2 = 'true';

      var DIME_OBVERSE = 'https://cdn.shopify.com/s/files/1/0661/4856/5211/files/coin-guide-roosevelt-dime-obverse.jpg?v=1787637109';
      var DIME_REVERSE = 'https://cdn.shopify.com/s/files/1/0661/4856/5211/files/coin-guide-roosevelt-dime-reverse.jpg?v=1787637157';
      var KENNEDY_BOTH = 'https://commons.wikimedia.org/wiki/Special:Redirect/file/Moneda%20de%20medio%20d%C3%B3lar%20USA%201964.jpg';
      var PEACE_BOTH = 'https://commons.wikimedia.org/wiki/Special:Redirect/file/NNC-US-1921-1%24-Peace%20dollar.jpg';

      var stage = lightbox.querySelector('[data-cg-lightbox-stage]');
      var view = lightbox.querySelector('[data-cg-lightbox-imageview]');
      var viewer = lightbox.querySelector('[data-cg-lightbox-image]');
      var title = lightbox.querySelector('[data-cg-lightbox-title]');
      var size = lightbox.querySelector('[data-cg-lightbox-size]');
      var scaleText = lightbox.querySelector('[data-cg-lightbox-scale]');
      var closeButton = lightbox.querySelector('[data-cg-lightbox-close]');
      var naturalWidth = 0;
      var naturalHeight = 0;
      var cropPx = { x: 0, y: 0, w: 0, h: 0 };
      var fitScale = 1;
      var currentScale = 1;
      var lastTrigger = null;

      function findCard(name) {
        var cards = root.querySelectorAll('.cg-realcoin');
        for (var i = 0; i < cards.length; i += 1) {
          var heading = cards[i].querySelector('.cg-coininfo h3');
          if (heading && heading.textContent.trim() === name) return cards[i];
        }
        return null;
      }

      function faceImages(card) {
        return card ? card.querySelectorAll('.cg-face img') : [];
      }

      function zoomImages(card) {
        return card ? card.querySelectorAll('.cg-zoom-window img') : [];
      }

      function setSource(img, url) {
        if (!img) return;
        img.removeAttribute('srcset');
        img.src = url;
      }

      function applySourceReplacements() {
        var dime = findCard('Roosevelt Dime');
        if (dime) {
          var df = faceImages(dime);
          var dz = zoomImages(dime);
          setSource(df[0], DIME_OBVERSE);
          setSource(df[1], DIME_REVERSE);
          setSource(dz[0], DIME_OBVERSE);
          setSource(dz[1], DIME_REVERSE);
          if (df[0]) df[0].alt = 'Roosevelt dime obverse real coin photograph';
          if (df[1]) df[1].alt = 'Roosevelt dime reverse real coin photograph';
          var ds = dime.querySelector('.cg-source');
          if (ds) ds.href = 'https://commons.wikimedia.org/wiki/File:Dime_Face_(16265763497).jpg';
        }

        var kennedy = findCard('Kennedy Half Dollar');
        if (kennedy) {
          var kf = faceImages(kennedy);
          var kz = zoomImages(kennedy);
          setSource(kf[0], KENNEDY_BOTH);
          setSource(kf[1], KENNEDY_BOTH);
          setSource(kz[0], KENNEDY_BOTH);
          setSource(kz[1], KENNEDY_BOTH);
          if (kf[0]) { kf[0].dataset.cgSide = 'left'; kf[0].alt = '1964 Kennedy half dollar obverse real coin photograph'; }
          if (kf[1]) { kf[1].dataset.cgSide = 'right'; kf[1].alt = '1964 Kennedy half dollar reverse real coin photograph'; }
          if (kz[0]) kz[0].dataset.cgFocus = '25,87';
          if (kz[1]) kz[1].dataset.cgFocus = '80,62';
          var ks = kennedy.querySelector('.cg-source');
          if (ks) ks.href = 'https://commons.wikimedia.org/wiki/File:Moneda_de_medio_d%C3%B3lar_USA_1964.jpg';
        }

        var peace = findCard('Peace Dollar');
        if (peace) {
          var pf = faceImages(peace);
          var pz = zoomImages(peace);
          setSource(pf[0], PEACE_BOTH);
          setSource(pf[1], PEACE_BOTH);
          setSource(pz[0], PEACE_BOTH);
          setSource(pz[1], PEACE_BOTH);
          if (pf[0]) { pf[0].dataset.cgSide = 'left'; pf[0].alt = '1921 Peace dollar obverse high-resolution real coin photograph'; }
          if (pf[1]) { pf[1].dataset.cgSide = 'right'; pf[1].alt = '1921 Peace dollar reverse high-resolution real coin photograph'; }
          if (pz[0]) pz[0].dataset.cgFocus = '25,86';
          if (pz[1]) pz[1].dataset.cgFocus = '72,73';
          var ps = peace.querySelector('.cg-source');
          if (ps) ps.href = 'https://commons.wikimedia.org/wiki/File:NNC-US-1921-1$_Peace_dollar.jpg';
        }

        var credit = root.querySelector('.cg-credit');
        if (credit) {
          credit.textContent = credit.textContent
            .replace('Roosevelt Dime — United States Mint, public domain', 'Roosevelt Dime — real coin photographs via Wikimedia Commons')
            .replace('1964 Kennedy Half Dollar — James St. John, CC BY 2.0', '1964 Kennedy Half Dollar — Amfeli, CC BY 4.0')
            .replace('Peace Dollar — Wikimedia Commons', '1921 Peace Dollar — National Numismatic Collection / Smithsonian Institution');
        }
      }

      function parseStyleFocus(img) {
        var explicit = img.dataset.cgFocus;
        if (explicit) {
          var ep = explicit.split(',').map(parseFloat);
          if (ep.length === 2 && isFinite(ep[0]) && isFinite(ep[1])) return { x: ep[0], y: ep[1] };
        }
        var style = img.getAttribute('style') || '';
        var xMatch = style.match(/--zx:\s*([0-9.]+)%/);
        var yMatch = style.match(/--zy:\s*([0-9.]+)%/);
        return {
          x: xMatch ? parseFloat(xMatch[1]) : 50,
          y: yMatch ? parseFloat(yMatch[1]) : 50
        };
      }

      function parseCrop(value) {
        if (!value) return null;
        var p = value.split(',').map(parseFloat);
        if (p.length !== 4 || p.some(function(v) { return !isFinite(v); })) return null;
        return { x: p[0], y: p[1], w: p[2], h: p[3] };
      }

      function cropAroundFocus(img, targetRatio, zoomFactor) {
        var nw = img.naturalWidth;
        var nh = img.naturalHeight;
        if (!nw || !nh) return null;
        var focus = parseStyleFocus(img);
        var cropW = nw / zoomFactor;
        var cropH = cropW / targetRatio;
        if (cropH > nh) {
          cropH = nh / zoomFactor;
          cropW = cropH * targetRatio;
        }
        var cx = nw * focus.x / 100;
        var cy = nh * focus.y / 100;
        var x = Math.min(Math.max(cx - cropW / 2, 0), nw - cropW);
        var y = Math.min(Math.max(cy - cropH / 2, 0), nh - cropH);
        return {
          x: x / nw * 100,
          y: y / nh * 100,
          w: cropW / nw * 100,
          h: cropH / nh * 100
        };
      }

      function paintCrop(img, crop) {
        var box = img.closest('.cg-face, .cg-zoom-window');
        if (!box || !crop) return;
        img.dataset.cgCrop = [crop.x, crop.y, crop.w, crop.h].join(',');
        box.classList.add('cg-crop-active');
        box.style.setProperty('--cg-crop-img-w', (10000 / crop.w) + '%');
        box.style.setProperty('--cg-crop-img-h', (10000 / crop.h) + '%');
        box.style.setProperty('--cg-crop-img-left', (-100 * crop.x / crop.w) + '%');
        box.style.setProperty('--cg-crop-img-top', (-100 * crop.y / crop.h) + '%');
      }

      function prepareImage(img) {
        function ready() {
          var isZoom = !!img.closest('.cg-zoom-window');
          if (isZoom) {
            paintCrop(img, cropAroundFocus(img, 4 / 3, 2.8));
          } else if (img.dataset.cgSide) {
            var squareWidth = Math.min(img.naturalHeight, img.naturalWidth / 2);
            var sideWidthPct = squareWidth / img.naturalWidth * 100;
            var sideX = img.dataset.cgSide === 'right' ? 100 - sideWidthPct : 0;
            paintCrop(img, { x: sideX, y: 0, w: sideWidthPct, h: 100 });
          }
        }
        if (img.complete && img.naturalWidth) ready();
        else img.addEventListener('load', ready, { once: true });
      }

      function cropToPixels(img) {
        var crop = parseCrop(img.dataset.cgCrop);
        if (!crop) return { x: 0, y: 0, w: img.naturalWidth, h: img.naturalHeight };
        return {
          x: img.naturalWidth * crop.x / 100,
          y: img.naturalHeight * crop.y / 100,
          w: img.naturalWidth * crop.w / 100,
          h: img.naturalHeight * crop.h / 100
        };
      }

      function getFitScale() {
        if (!cropPx.w || !cropPx.h) return 1;
        var w = Math.max(stage.clientWidth - 56, 100);
        var h = Math.max(stage.clientHeight - 56, 100);
        return Math.min(w / cropPx.w, h / cropPx.h, 1);
      }

      function renderViewer() {
        if (!naturalWidth || !naturalHeight) return;
        view.style.width = Math.max(1, Math.round(cropPx.w * currentScale)) + 'px';
        view.style.height = Math.max(1, Math.round(cropPx.h * currentScale)) + 'px';
        viewer.style.width = Math.max(1, Math.round(naturalWidth * currentScale)) + 'px';
        viewer.style.height = Math.max(1, Math.round(naturalHeight * currentScale)) + 'px';
        viewer.style.left = Math.round(-cropPx.x * currentScale) + 'px';
        viewer.style.top = Math.round(-cropPx.y * currentScale) + 'px';
        scaleText.textContent = Math.round(currentScale * 100) + '%';
      }

      function setScale(nextScale) {
        if (!naturalWidth) return;
        currentScale = Math.min(1, Math.max(fitScale, nextScale));
        renderViewer();
      }

      function openImage(img) {
        lastTrigger = img;
        title.textContent = img.getAttribute('alt') || 'Coin image';
        lightbox.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        viewer.onload = function() {
          naturalWidth = viewer.naturalWidth;
          naturalHeight = viewer.naturalHeight;
          cropPx = cropToPixels(img);
          var isCrop = !!img.dataset.cgCrop;
          size.textContent = isCrop
            ? Math.round(cropPx.w) + ' × ' + Math.round(cropPx.h) + ' px crop from ' + naturalWidth + ' × ' + naturalHeight + ' px original'
            : naturalWidth + ' × ' + naturalHeight + ' px original';
          fitScale = getFitScale();
          currentScale = fitScale;
          renderViewer();
          stage.scrollLeft = 0;
          stage.scrollTop = 0;
        };
        viewer.src = img.currentSrc || img.src;
        viewer.alt = img.alt || 'Expanded coin image';
      }

      function closeImage() {
        lightbox.hidden = true;
        document.documentElement.style.overflow = '';
        viewer.removeAttribute('src');
        naturalWidth = 0;
        naturalHeight = 0;
        cropPx = { x: 0, y: 0, w: 0, h: 0 };
        if (lastTrigger) lastTrigger.focus();
      }

      applySourceReplacements();

      var images = root.querySelectorAll('.cg-face img, .cg-zoom-window img');
      images.forEach(function(img) {
        prepareImage(img);
        img.tabIndex = 0;
        img.setAttribute('role', 'button');
        img.setAttribute('aria-label', 'Enlarge ' + (img.alt || 'coin image'));
        img.addEventListener('click', function() { openImage(img); });
        img.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openImage(img);
          }
        });
      });

      closeButton.addEventListener('click', closeImage);
      lightbox.addEventListener('click', function(event) {
        if (event.target === lightbox) closeImage();
      });

      lightbox.querySelectorAll('[data-cg-lightbox-action]').forEach(function(button) {
        button.addEventListener('click', function() {
          var action = button.getAttribute('data-cg-lightbox-action');
          if (action === 'in') setScale(currentScale * 1.35);
          if (action === 'out') setScale(currentScale / 1.35);
          if (action === 'fit') { fitScale = getFitScale(); setScale(fitScale); }
          if (action === 'native') setScale(1);
        });
      });

      document.addEventListener('keydown', function(event) {
        if (lightbox.hidden) return;
        if (event.key === 'Escape') closeImage();
        if (event.key === '+' || event.key === '=') setScale(currentScale * 1.25);
        if (event.key === '-') setScale(currentScale / 1.25);
        if (event.key === '0') { fitScale = getFitScale(); setScale(fitScale); }
      });

      window.addEventListener('resize', function() {
        if (lightbox.hidden || !naturalWidth) return;
        fitScale = getFitScale();
        currentScale = Math.max(fitScale, Math.min(currentScale, 1));
        renderViewer();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCoinGuideLightboxV2);
    } else {
      initCoinGuideLightboxV2();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomlov-p1-copy-fixes"]) return;
  try {
    
(() => {
  const applyFixes = () => {
    document.querySelectorAll('.shopify-section--rich-text').forEach((root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.includes('Seriesdelivers')) {
          node.nodeValue = node.nodeValue.replaceAll('Seriesdelivers', 'Series delivers');
        }
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes, { once: true });
  } else {
    applyFixes();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
